import {assetIsPresent} from '@netx/core-asset-next/enablers/assetIsPresent';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {type IAsset} from '../schema';
import {assetCheckedOut} from './assetCheckedOut';

export const canDownloadAsset = (asset?: IAsset): boolean => {
	if (asset == null) return false;
	if (assetCheckedOut(asset)) return false;
	if (!assetIsPresent(asset)) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.DOWNLOAD,
		permissionName: PermissionName.DOWNLOAD,
	});
};
